import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { JFSEService } from '@services/jfse';
import { catchError, tap } from 'rxjs/operators';
import { JfseIframeModalComponent } from '@app/shared/modals/jfse/jfse-iframe-modal/jfse-iframe-modal.component';
import { of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalRightService } from '@services/modal';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import Vital from '@app/shared/types/jfse/vital';
import JfseUtils from '@app/shared/utils/jfse.utils';

@Component({
    selector: 'app-jfse-vital-sync',
    templateUrl: './jfse-vital-sync.component.html',
    styleUrls: ['./jfse-vital-sync.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class JfseVitalSyncComponent implements OnInit {
    @Output() runRes = new EventEmitter<any>();
    onIframeRes = new EventEmitter<any>();
    runError = new EventEmitter<any>();
    @Input() synced = false;
    @Input() patient;
    onSync = false;
    vital: Vital;

    constructor(
        private readonly jfseService: JFSEService,
        private readonly modalRightService: ModalRightService,
        private readonly toastrService: ToastrService,
        private readonly translateService: TranslateService,
    ) {}

    ngOnInit(): void {
        this.onIframeRes
            .pipe(
                tap((res) => {
                    this.vital.datas.noBeneficiaireSelectionne = res + 1;
                    this.updatePatientByCv();
                    this.runRes.emit(this.vital.datas);
                    this.toastrService.success(
                        this.translateService.instant(
                            'inclusion.identity.vital.success',
                        ),
                    );
                    this.onSync = false;
                }),
                untilDestroyed(this),
            )
            .subscribe();
    }

    syncVital() {
        this.onSync = true;
        this.jfseService
            .readVital()
            .pipe(
                tap(({ url, cvDatas }) => {
                    this.vital = new Vital(cvDatas);
                    this.modalRightService.open(JfseIframeModalComponent, {
                        url,
                        runRes: this.onIframeRes,
                        runError: this.runError,
                    });
                }),
                catchError((err) => {
                    this.onSync = false;
                    return of(err);
                }),
                untilDestroyed(this),
            )
            .subscribe();
    }

    private updatePatientByCv() {
        const beneficiary = this.vital.readBeneficiary(
            this.vital.datas.noBeneficiaireSelectionne,
        );
        this.patient.lastName = beneficiary.nomUsuel;
        this.patient.firstName = beneficiary.prenom;
        this.patient.ins = beneficiary.INSC;
        this.patient.birthDate = JfseUtils.jfseBirthDate2Moment(
            beneficiary.dateNaissance,
        ).valueOf();
        this.patient.socialSecurityNumber = this.vital.socialSecurityNumber;
    }
}
